import { Layout, Flex, Avatar, Dropdown, Space, Typography, message, Divider } from 'antd';
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import { CaretRightOutlined, DownOutlined, ExclamationCircleOutlined, LogoutOutlined, RetweetOutlined, UserOutlined } from '@ant-design/icons';
import authService from '../../configs/auth/authServices';
import { useCurrentUserContext } from '../../context/currentUserContext';
import ResetUserPassword from '../../pages/users/resetUserPassword';
import { useState } from 'react';
import { notifyMessages } from '../../utils/constants';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = () => {
    const { currentUser } = useCurrentUserContext();
    const [resetPasswordDrawer, setResetPasswordDrawer] = useState(false);

    const onResetDrawerClose = () => {
        setResetPasswordDrawer(false);      
    }

    const onSignOut = () => {
        authService.logout();

        //clear documents stored filters
        localStorage.removeItem("documentsListFilters");
        localStorage.removeItem("documentsListPage");
        localStorage.removeItem("documentsListSorter");

        //clear documents fgas stored filters
        localStorage.removeItem("fgasDocumentsListFilters");
        localStorage.removeItem("fgasDocumentsListPage");
        localStorage.removeItem("fgasDocumentsListSorter");

        //clear documents distinte stored filters
        localStorage.removeItem("distinteDocumentsListFilters");
        localStorage.removeItem("distinteDocumentsListPage");
        localStorage.removeItem("distinteDocumentsListSorter");

    }

    const items = [
        {
            label: (<Text onClick={() => onSignOut()}><LogoutOutlined /> Sign Out</Text>),
            key: '1'
        },
        {
            type: 'divider',
        },
        {
            label: (<Text onClick={() => setResetPasswordDrawer(true)}><RetweetOutlined /> Cambia password</Text>),
            key: '2'
        }
    ];


    return (
        <Header className='appheader'>
            <Flex gap="middle" align="center" justify='space-between' style={{ height: "inherit" }}>

                {currentUser && (
                    <ResetUserPassword open={resetPasswordDrawer} onClose={() => onResetDrawerClose()} recordData={currentUser} />
                )}

                <Space className="logo">
                    <Link to={{ pathname: `/` }}><img src={logo} alt="LOGO" /></Link>
                </Space>
                <Space>
                    <Avatar icon={<UserOutlined />} />
                    <Dropdown menu={{ items }}>
                        <Space>
                            {currentUser && (
                                <>
                                    <Text>{currentUser?.name || currentUser?.username} {currentUser?.surname || ''} </Text>
                                    <DownOutlined />
                                </>
                            )}
                            {!currentUser && (<ExclamationCircleOutlined color='#fefefe' />)}
                        </Space>
                    </Dropdown>
                </Space>
            </Flex>
        </Header>
    );
}


export default AppHeader;